"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const onchainTypes_1 = require("../../onchainTypes");
const onchainAccountPoolToken_1 = __importDefault(require("../onchainAccountPoolToken"));
class OnchainAccountCollateral extends onchainAccountPoolToken_1.default {
    constructor(lendingPool) {
        super();
        this.collateralCache = {};
        this.getLendingPool = () => this.lendingPool;
        this.getPoolToken = () => this.poolToken;
        this.getAccount = () => this.lendingPool.getAccount();
        this.getInteractionsCollateral = this.getInteractionsPoolToken;
        this.getOffchainAccountCollateral = this.getOffchainAccountPoolToken;
        this.lendingPool = lendingPool;
        this.poolToken = lendingPool.getLendingPool().getCollateral();
    }
    getInteractionsPoolToken() {
        return this.lendingPool.getInteractionsLendingPool().getCollateral();
    }
    getOffchainAccountPoolToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const offchainAccountLendingPool = yield this.lendingPool.getOffchainAccountLendingPool();
            return offchainAccountLendingPool.getCollateral();
        });
    }
    cleanCache() {
        super.cleanCache();
        this.collateralCache = {};
    }
    fixStakedLPExchangeRate(n) {
        return __awaiter(this, void 0, void 0, function* () {
            const stakedLPExchangeRate = yield this.poolToken.getLendingPool().getStakedLPExchangeRate();
            return (yield n) / stakedLPExchangeRate;
        });
    }
    getAvailableBalanceUSD() {
        const _super = Object.create(null, {
            getAvailableBalanceUSD: { get: () => super.getAvailableBalanceUSD }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return this.fixStakedLPExchangeRate(_super.getAvailableBalanceUSD.call(this));
        });
    }
    getDepositedUSD() {
        const _super = Object.create(null, {
            getDepositedUSD: { get: () => super.getDepositedUSD }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return this.fixStakedLPExchangeRate(_super.getDepositedUSD.call(this));
        });
    }
    // Max Withdrawable
    /*public async getMaxWithdrawable() : Promise<number> {
      const deposited = await this.getDeposited();
      const availableCash = await this.poolToken.getTotalBalance();
      const { valueCollateral, valueA, valueB } = await this.lendingPool.getValues(NO_CHANGES);
      const safetyMargin = (await this.lendingPool.getSafetyMargin()) * this.getUiMargin();
      const liquidationPenalty = await this.lendingPool.getLiquidationPenalty();
      const actualCollateral = valueCollateral / liquidationPenalty;
      const maxWithdrawable1 = (actualCollateral - (valueA + valueB * safetyMargin) / Math.sqrt(safetyMargin)) * liquidationPenalty / this.getDust();
      const maxWithdrawable2 = (actualCollateral - (valueB + valueA * safetyMargin) / Math.sqrt(safetyMargin)) * liquidationPenalty / this.getDust();
      return Math.max(0, Math.min(deposited, availableCash, maxWithdrawable1, maxWithdrawable2));
    }*/
    // binary search approach
    getMaxWithdrawable() {
        return __awaiter(this, void 0, void 0, function* () {
            const collateralAmount = yield this.getDeposited();
            const twapPrice = yield this.lendingPool.getLendingPool().getTWAPPrice();
            const [liqPriceA, liqPriceB] = yield this.lendingPool.getLiquidationPrices(onchainTypes_1.NO_CHANGES);
            // start search
            let withdrawAmount = collateralAmount;
            let withdrawAmountPrev = 0;
            let bestAmount = 0;
            for (let i = 0; i < 1000; i++) {
                const jump = Math.abs(withdrawAmount - withdrawAmountPrev) / 2;
                if (jump / collateralAmount < 0.000001)
                    break;
                withdrawAmountPrev = withdrawAmount;
                const changeCollateral = -1 * Math.min(withdrawAmount, collateralAmount);
                const changeBorrowedA = 0;
                const changeBorrowedB = 0;
                const changes = { changeCollateral, changeBorrowedA, changeBorrowedB };
                const [liqPriceA, liqPriceB] = yield this.lendingPool.getLiquidationPrices(changes);
                if (liqPriceA * this.getUiMargin() > twapPrice || liqPriceB / this.getUiMargin() < twapPrice)
                    withdrawAmount -= jump;
                else {
                    bestAmount = withdrawAmount;
                    withdrawAmount += jump;
                    if (withdrawAmount > collateralAmount)
                        break;
                }
            }
            return bestAmount * this.getDust();
        });
    }
}
exports.default = OnchainAccountCollateral;
